import React from "react"
import { MainCP } from "../../../Components/delincuencia/delincuencia-v2/MainCP"

const ViewDelincuencia: React.FC = () => <MainCP/>

export default ViewDelincuencia